type IconProps = React.SVGProps<SVGSVGElement>;

const People: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2612 21.1797C19.1225 19.9855 25.4067 24.3581 26.7964 31.3174C26.9476 32.0758 26.9947 32.8618 27.0308 33.6387C27.0708 34.4885 26.549 34.999 25.7124 34.999C21.9751 35.0011 18.2378 34.999 14.5005 34.999L14.5015 35H3.47705C2.41805 35 1.98646 34.5469 2.00049 33.4521C2.08075 27.4945 6.52514 22.1791 12.2612 21.1797ZM27.7358 21.1914C32.523 20.5497 36.7849 23.6073 37.8091 28.4219C37.9223 28.9559 37.9745 29.5092 37.9976 30.0566C38.0385 31.0415 37.5598 31.5312 36.6011 31.5322C34.9009 31.5353 33.2007 31.5322 31.5005 31.5322C30.8503 31.5322 30.1995 31.527 29.5503 31.5352C29.3573 31.5371 29.2641 31.4893 29.2271 31.2725C28.6329 27.8242 27.1174 24.8847 24.5806 22.5137C24.5457 22.481 24.5198 22.438 24.4712 22.377C25.4937 21.747 26.5762 21.3462 27.7358 21.1914ZM28.9976 9.21582C31.815 9.21377 34.1038 11.5475 34.1069 14.4258C34.1099 17.3063 31.8257 19.6493 29.0112 19.6523C26.196 19.6542 23.9068 17.3177 23.9038 14.4404C23.9018 11.559 26.1831 9.21792 28.9976 9.21582ZM14.4302 5C18.2807 4.9795 21.3527 8.09304 21.3657 12.0283C21.3787 15.8804 18.3141 19.0215 14.5269 19.0381C10.7675 19.0535 7.65278 15.8877 7.65479 12.0508C7.6558 8.19246 10.704 5.01959 14.4302 5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default People;
